/**
 * Fundbox Fuse — environment configuration.
 *
 * Reads VITE_FUNDBOX_FUSE_DOMAIN, VITE_FUNDBOX_FUSE_PARTNER_ID, and optional
 * VITE_FUNDBOX_OAUTH_CLIENT_ID. Builds the fuse.js script URL. Returns null
 * when required vars are missing so callers can no-op.
 *
 */

export interface FundboxFuseConfig {
  domain: string;
  partnerId: string;
  scriptUrl: string;
  /**
   * Environment-specific Fundbox OAuth client id. When present, the embed exchanges the
   * current user's token for a short-lived auth code (FSS OAuth) before launching fuse.js.
   */
  oauthClientId?: string;
}

/**
 * Reads Fundbox Fuse env configuration. Returns null when required vars are missing.
 */
export function getFundboxFuseConfig(): FundboxFuseConfig | null {
  const domain = import.meta.env.VITE_FUNDBOX_FUSE_DOMAIN;
  const partnerId = import.meta.env.VITE_FUNDBOX_FUSE_PARTNER_ID;

  if (!domain || !partnerId) {
    return null;
  }

  const oauthClientId = import.meta.env.VITE_FUNDBOX_OAUTH_CLIENT_ID;

  return {
    domain,
    partnerId,
    scriptUrl: `https://${domain}/static/dist/fuse/v1/fuse.js`,
    oauthClientId: oauthClientId || undefined,
  };
}
